import { render, staticRenderFns } from "./row.vue?vue&type=template&id=ddd695e6&scoped=true"
import script from "./row.vue?vue&type=script&lang=js"
export * from "./row.vue?vue&type=script&lang=js"
import style0 from "./row.vue?vue&type=style&index=0&id=ddd695e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd695e6",
  null
  
)

export default component.exports